import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 54px;
  flex-shrink: 0;
  padding: 8px 14px;
  border-radius: 16px 16px 0 0;
  background-image: linear-gradient(
    160deg,
    rgba(255, 255, 255, 0.14),
    rgba(255, 255, 255, 0)
  );

  h6 {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    white-space: nowrap;
    margin: 0;
  }

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border-radius: 11px;
    background-color: rgba(255, 255, 255, 0.25);
    font-size: 11px;
    font-weight: 700;
  }
`;

export const TitleLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const IconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: rgba(255, 255, 255, 0.95);
`;

export const TitleText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  h5 span {
    font-size: 16px;
    margin-bottom: 4px;
  }
`;

export const Subtitle = styled.span`
  font-size: 10px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
`;

export const List = styled.ul`
  width: 100%;
  padding: 6px;
  margin: 0;
  overflow-y: auto;
  flex-grow: 1;

  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.text}12;
    border-radius: 3px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.text}25;
    }
  }
`;

export const ListItem = styled.li`
  list-style: none;
  animation: ${slideIn} 0.2s ease-out;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  text-align: center;
  gap: 12px;
  opacity: 0.55;
`;

export const EmptyIconRing = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1.5px dashed ${({ theme }) => theme.colors.text}30;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
